module.exports = __webpack_public_path__ + "static/img/arrow.be635e4b.png";